import { HttpEvent, HttpEventType } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { interval, Subscription } from 'rxjs';
import { CustomerService } from 'src/app/services/customer.service';
import { SharedService } from 'src/app/services/shared.service';

@Component({
    selector: 'app-import-export-customers',
    templateUrl: './import-export-customers.component.html',
    styleUrls: ['./import-export-customers.component.scss']
})
export class ImportExportCustomersComponent implements OnInit, OnDestroy {

    isImportingCustomers: boolean = true;
    isExportingCustomers: boolean = false;

    companyCode = localStorage.getItem('company_code');

    intervalId: any;
    seconds: number = localStorage.getItem("export_seconds") ? parseInt(localStorage.getItem("export_seconds")) : 0;
    status: string = '';
    private timerSubscription: Subscription;

    constructor(
        private sharedService: SharedService,
        private customerService: CustomerService,
    ) { }

    ngOnInit(): void {
        this.startTimer();
        this.checkImportCustomerStatus();
        localStorage.setItem("export_customers", "1");
        this.intervalId = setInterval(() => {
            this.checkImportCustomerStatus();
        }, 15000);
    }

    get checkIsExporting(){
        return localStorage.getItem("is_exporting_model");
    }

    startTimer() {
        this.timerSubscription = interval(1000).subscribe(() => {
            if (this.status !== 'complete') {
                this.seconds++;
                localStorage.setItem("export_seconds", this.seconds?.toString());
            } else {
                this.timerSubscription.unsubscribe();
            }
        });
    }

    checkImportCustomerStatus() {
        this.isImportingCustomers = true;

        this.customerService
            .importCustomerStatus(this.companyCode)
            .subscribe((res: any) => {
                if (res?.result != 'InProcess') {
                    this.sharedService.isComplete(res?.result);
                    this.sharedService.isImport(false);
                    localStorage.removeItem("export_customers");
                    localStorage.removeItem("export_seconds");
                    this.isImportingCustomers = false;
                    if (this.timerSubscription) {
                        this.timerSubscription.unsubscribe();
                    }
                }
            }, (error) => {
                this.isImportingCustomers = false;
                if (error instanceof Object) {
                    if (error["ResponseException"] != "") {
                        alert(error["ResponseException"]);
                    }
                }
                localStorage.removeItem("export_customers");
                localStorage.removeItem("export_seconds");
                if (this.intervalId) {
                    clearInterval(this.intervalId);
                    this.intervalId = null;
                }
                if (this.timerSubscription) {
                    this.timerSubscription.unsubscribe();
                }
                this.sharedService.isImport(false);
                console.log(error);
            })
    }

    formatTime(totalSeconds: number): string {
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
    
        const parts = [];
        if (hours > 0) parts.push(`${hours}h`);
        if (minutes > 0 || hours > 0) parts.push(`${minutes}m`);
        parts.push(`${seconds}s`);
    
        return parts.join(' ');
      }
    

    ngOnDestroy() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }

        if (this.timerSubscription) {
            this.timerSubscription.unsubscribe();
        }

        localStorage.removeItem("export_customers");
        localStorage.removeItem("export_seconds");
    }


}
